<template>
  <div class="decoration-page">
    <EsHeaderView />
    <div v-if="isPreview" style="background: linear-gradient(135deg, #4d6bfe, #7388ff); color: #fff; text-align: center; padding: 8px 16px; font-size: 13px; font-weight: 500; position: sticky; top: 0; z-index: 100;">{{ $t('message.home.🔍 预览模式 · 当前显示的是装修器中的草稿内容（未发布）') }}</div>
    <DecorationRenderer v-if="loaded && components.length" :components="components" :scope-page-type="3" />
    <div v-else-if="loaded" class="dp-empty">
      <el-empty :description="$t('message.home.noData')"></el-empty>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import DecorationRenderer from "@/components/decoration/DecorationRenderer.vue";
import { getDecorationPage } from "@/api/upms/decoration";

export default {
  name: "DecorationPage",
  components: { DecorationRenderer },
  data() {
    return { loaded: false, components: [], isPreview: false };
  },
  watch: {
    "$route.params.pageKey": function () { this.load(); }
  },
  mounted() {
    this.load();
  },
  methods: {
    /** 按 pageKey 拉取已发布的活动/自定义页装修配置；?previewPageId=xxx 走草稿接口供装修器预览 */
    load() {
      this.loaded = false;
      this.components = [];
      this.isPreview = false;
      const previewPageId = this.$route.query && this.$route.query.previewPageId;
      const pageKey = this.$route.params.pageKey;
      const params = previewPageId ? { previewPageId } : { terminalType: 0, pageKey };
      getDecorationPage(params).then(r => {
        const page = r && r.data && r.data.data;
        if (page && page.componentListJson) {
          let parsed = null;
          try { parsed = JSON.parse(page.componentListJson); } catch (e) { parsed = null; }
          if (parsed && Array.isArray(parsed.components)) {
            this.components = parsed.components;
            this.isPreview = !!previewPageId;
          }
        }
      }).catch(() => { /* 接口异常 → 空态 */ }).finally(() => { this.loaded = true; });
    }
  }
};
</script>

<style scoped>
.decoration-page { min-height: 100vh; }
.dp-empty { padding: 80px 0; }
</style>
